(function () {
  'use strict';

  angular
    .module('dashboard.stats')
    .config(config);

  function config() {
  }
}());
